export default "__VITE_ASSET__rTYG9QQa__"